import { forwardRef, useEffect, useRef } from "react";
import classnames from "classnames";
import HiddenField from "./HiddenField";
import styles from "@/styles/Form.module.scss";

const ReadOnlyField = forwardRef((props, ref) => {
  const {
    error,
    name,
    className,
    title,
    titleCenter,
    caption,
    required,
    value,
    ..._props
  } = props;
  const input = useRef();
  useEffect(() => {
    if (input.current) {
      input.current.value = value;
    }
  }, [value]);

  return (
    <div className={styles.inputField}>
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.center]: titleCenter,
            [styles.required]: required,
          })}
        >
          {title}
        </legend>
      )}
      <input
        ref={input}
        type="text"
        name={name}
        className={classnames(styles.textInput, className)}
        defaultValue=""
        tabIndex="-1"
        disabled
        readOnly
        {..._props}
      />
      <HiddenField ref={ref} name={name} value={value} />
      {caption && <p className={styles.caption}>{caption}</p>}
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
});
ReadOnlyField.displayName = "ReadOnlyField";
export default ReadOnlyField;
